import { ISavedAddressType } from "../types";
import { ADM_SAVED_ADDRESSES_FETCH, ADM_SAVED_ADDRESSES_ADD, ADM_SAVED_ADDRESSES_EDIT, ADM_SAVED_ADDRESSES_REMOVE, ADM_SAVED_ADDRESSES_ERROR } from "../store/types";

const INITIAL_STATE = {
    date: [],
    loading: false,
    error: {
        msg: null,
        flag: false,
    }
};

export const admSavedAddressesReducer = (state = INITIAL_STATE, action: any) => {
    switch (action.type) {
        case ADM_SAVED_ADDRESSES_FETCH:
            return {
                ...state,
                date: action.payload,
                loading: false
            };
        case ADM_SAVED_ADDRESSES_ADD:
            return {
                ...state,
                date: [...state.date, action.payload],
                loading: false
            };
        case ADM_SAVED_ADDRESSES_EDIT:
            const updatedData = state.date.map((item: ISavedAddressType) =>
                item.id === action.payload.id ? action.payload : item
            );
            return {
                ...state,
                date: updatedData,
                loading: false
            };
        case ADM_SAVED_ADDRESSES_REMOVE:
            const filteredData = state.date.filter((item: ISavedAddressType) => item.id !== action.payload.id);
            return {
                ...state,
                date: filteredData,
                loading: false
            };
        case ADM_SAVED_ADDRESSES_ERROR:
            return {
                ...state,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        default:
            return state;
    }
};